import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { AdSense } from '../components/AdSense';

export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    console.log('🔑 LOGIN SUBMIT:', { email, password: password ? '***' : 'empty' });

    try {
      console.log('📤 Sending request to /api/login...');
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      console.log('📥 Response from server:', {
        status: response.status,
        ok: response.ok,
        success: data.success,
        message: data.message,
      });

      if (!response.ok) {
        console.log('❌ Login failed:', data.message);
        setError(data.message || 'Login failed');
        setLoading(false);
        return;
      }

      // Save session to localStorage
      if (data.session && data.user) {
        console.log('💾 Saving session to localStorage...');
        console.log('Session token:', data.session.token.substring(0, 20) + '...');
        console.log('User role:', data.user.role);
        console.log('User email:', data.user.email);

        localStorage.setItem('session_token', data.session.token);
        localStorage.setItem('app_session_token', data.session.token);
        localStorage.setItem('user_role', data.user.role);
        localStorage.setItem('user_email', data.user.email);
        localStorage.setItem('user_id', data.user.id);

        console.log('✅ Session saved!');

        // Redirect to dashboard based on role
        const dashboard = data.user.role === 'admin' ? '/admin-dashboard' : '/user-dashboard';
        console.log('🚀 Redirecting to:', dashboard);
        navigate(dashboard, { replace: true });
      }
    } catch (err) {
      console.error('❌ Network error:', err);
      setError('Connection error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-6 col-sm-8">
            <div className="card shadow border-0 rounded-lg">
              <div className="card-body p-4">
                <h2 className="card-title text-center mb-4 fw-bold">Login</h2>

                {error && <div className="alert alert-danger mb-4">{error}</div>}

                <form onSubmit={handleLogin}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                      autoComplete="email"
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input
                      type="password"
                      id="password"
                      className="form-control"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      disabled={loading}
                      autoComplete="current-password"
                    />
                  </div>

                  <div className="mb-3">
                    <Link to="/forgot-password" className="text-decoration-none small">
                      Forgot password?
                    </Link>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary w-100 btn-lg"
                    disabled={loading}
                  >
                    {loading ? 'Logging in...' : 'Login'}
                  </button>
                </form>

                <div className="mt-4 text-center">
                  <p className="text-muted">
                    Don't have an account?{' '}
                    <Link to="/signup" className="text-decoration-none fw-bold">
                      Sign up here
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AdSense />

        <Footer />
      </div>
    </div>
  );
}

